import image from './assets/funciona.png'
import imageMobile from './assets/funciona-mobile.png'
import circleArrow from './assets/circle-arrow.png'

const Funciona = () => {
    return ( 
        <div className="funciona" id='funciona'>
            <div className="funciona-texts">
                <h2>Jogo é diversão, <span className='funciona-blue-text'>sua vida não!</span></h2>
                <span>Identificamos padrões de comportamento com cuidado humano oferecemos suporte psicológico e trabalhamos em parceria com empresas de apostas para promover o bem estar dos jogadores.</span>
                <div className="funciona-buttons">
                    <a className='funciona-started' href='https://www.youtube.com/watch?v=qkm-JE08l4k&feature=youtu.be' rel='noreferrer' target='_blank'>Assista <img src={circleArrow} alt="" /></a>
                    <a className="funciona-contato" rel='noreferrer' target='_blank'  href='https://api.whatsapp.com/send?phone=558006761000&text=Olá! Gostaria de tirar algumas dúvidas sobre o Instituto.'>Fale conosco</a>
                </div>
            </div>
            <img className='background-image-mobile' src={imageMobile} alt="" />
            <img className='background-image' src={image} alt="" />
        </div>
        );
}
 
export default Funciona;